<template>
  <div class="formHead">
    <p>./startForm</p>
    <a :href="handlingUserDataLink">(Informationen zu unserem Umgang mit Bewerberdaten)</a>
    <div class="formBody">
      <form id="formID">
    <div class="form">
      <p>Geschlecht (M/W/D):</p>
      <input ref="message" v-model="mailContent.form_anrede" type="text" @keydown.enter="execute"/>
    </div>
    <div class="form">
      <p>Vorname:</p>
  <input  v-model="mailContent.form_vorname" type="text" @keydown.enter="focusNext"/>
    </div>
    <div class="form">
      <p>Nachname:</p>
  <input  v-model="mailContent.form_nachname" type="text" @keydown.enter="focusNext"/>
    </div>
    <div class="form">
      <p>E-Mailadresse:</p>
  <input  v-model="mailContent.form_email" type="text" @keydown.enter="focusNext"/>
    </div>
    <div class="form">
      <p>Telefonnummer:</p>
        <input  v-model="mailContent.form_telefon" type="text" @keydown.enter="focusNext"/>
    </div>
    <div class="form">
      <p>Wie bist du auf unser Unternehmen gestoßen?:</p>
      <input  v-model="mailContent.form_aufmerksam_geworden" type="text" @keydown.enter="focusNext"/>
    </div>
    <div class="form">
      <p>Mit dem Absenden des Bewerbungsformulars erklärst Du Dich mit der Speicherung Deiner personenbezogenen Daten gemäß unserer Datenschutzerklärung einverstanden[J/N]</p>
      <input  v-model="mailContent.dsgvo" type="text" @keydown.enter="sendMail"/>
    </div>
</form>
    </div>
  </div>
  <button class="button" @click="sendMail">Absenden</button>
</template>

<script setup>
import { ref, defineEmits } from 'vue';
import { handlingUserDataLink  } from "../pages/home/vars.js";

const emit = defineEmits(['filledOutForm'])


const mailContent = ref({});
const mailVars = mailContent.value;

function execute(e){
  focusNext(e)
}

function focusNext(e) {
  const inputs = Array.from(e.target.form.querySelectorAll('input[type="text"]'));
  const index = inputs.indexOf(e.target);

  if (index < inputs.length) {
    inputs[index + 1].focus();
  }
}
function printElements(){
  let formData = new FormData();
  let dsgvo_var;
  for (let key in mailVars ) {
    if (mailVars[key]=="J"){
      formData.delete("dsgvo");
      dsgvo_var = ["", "1"];
      formData.append(key, dsgvo_var);
    } else if(mailVars[key]=="N"){
      formData.delete("dsgvo");
      dsgvo_var = ["1", ""];
      formData.append(key, dsgvo_var);
    } 
    if (key=="dsgvo"){
      continue;
    }
    formData.append(key, mailVars[key]);
  }
  let formDataFiller = {
    form_bewerbung_als: 'Quiz Löser',
    form_geburtsdatum: '-',
    form_wohnort: '-',
    form_gehaltsvorstellung: '-',
    form_hoechste_schulbildung: '-',
    form_karriere_step_typ: '-',
    form_technische_schwerpunkte: '-',
    form_berufserfahrung: '-',
    form_zertifikate: '-',
    form_englischkenntnisse: '-',
    form_deutschkenntnisse: '-',
    form_drei_dinge: '-',
  }
  for (let key in formDataFiller ) {
    formData.append(key, formDataFiller[key]);
  }
  return formData;
}

function sendMail(){
  const requestOptions = {
    method: "POST",
    body: printElements(),
  };
  fetch("https://www.gonicus.de/_jobmail/jobmail.php", requestOptions)
    .then(response => response.json())
    .then(response => console.log(response))
    .catch(err => console.log(err));

  //parent component changes to GoodByeDialog after this emit
  emit('filledOutForm');

} 

</script>

<style scoped>
a{
  font-size: 1rem;
}
.formHead{
  color:#0f0;
  text-align: left;
  font-family: monospace;
}
.formBody{
  display:flex;
  flex-direction: column;
}
.form{
  display:flex;
}
input{
  background-color: transparent;
  color: #0f0;
  border: none;
  display: inline;
  outline: none;
  font-size: 1.5rem;
}
.button{
  margin:auto;
  font: monospace;
  background-color:#0f0;
  border:none;
  width: 100%;

}
</style>